const { scrollmagic } = require("./modules/scrollmagic");
const { pageTop } = require("./modules/pageTop");
const { smooth } = require("./modules/smooth");

scrollmagic();
pageTop();
smooth();
